import { makeStyles } from "@mui/styles"

const useStylesAutenticateModal = makeStyles(() => ({
  typographyStyle: {
    fontSize: "1.5rem",
    fontFamily: "Roboto",
  },
  boxStyle: {
    display: "flex",
    padding: 10,
    flexDirection: "column",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: 324,
    borderRadius: "8px",
    background: "#fff",
  },
  boxStyle2: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  circularProgress: {
    color: "#00A88F",
  },
  start: {
    animation: "spin",
    AnimationTimeline: "1s",
    animationIterationCount: 1,
  },
  "@-moz-keyframes spin": {
    from: "-moz-transform: rotate(0deg)",
    to: "-moz-transform: rotate(360deg)",
  },
  "@-webkit-keyframes spin": {
    from: "-webkit-transform: rotate(0deg)",
    to: "-webkit-transform: rotate(360deg)",
  },
  "@keyframes spin": {
    from: "transform:rotate(0deg)",
    to: "transform:rotate(360deg)",
  },
  icon: {
    color: "#00A88F",
    animationDuration: "3s",
    animationName: "revert",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
  },
  subtitle: {
    marginLeft: 4,
    fontSize: 20,
    color: "#262323",
  },
  badIcon: {
    color: "#026873",
    fontSize: 26,
  },
  errorIcon: {
    color: "#590817",
    fontSize: 26,
  },
}))

export default useStylesAutenticateModal
